import {createContext} from 'react'

export const ServiceSideCostPaymentContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  serviceSideCostPayments: [],
  setServiceSideCostPayments: () => {
  },
  serviceSideCostPayment: {
    id: null,
    person_name: "",
    agent_name: "",
    branch_name: "",
    step: "",
    site_share: null,
    vat_share: null,
    agent_share: null,
    status: "",
    total: null,

  },
  setServiceSideCostPayment: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
})